import React from "react";

export const ColumnContent = ({ layout, children }) => (
  <div className={`columnContent ${layout ? `layout-${layout}` : ""}`}>
    {children}
  </div>
);
